import React from "react"
import { useTranslation } from "react-i18next"
import { languageSuffixMap } from "constant"

import { thousandSeparator } from "utils"
import classes from "./KcSummery.module.scss"

const KcSummery = (props) => {
  const {
    total,
    subtotal,
    taxesAndCharges,
    totalFoodDiscounts
  } = props

  const [t, i18n] = useTranslation()

  return (
    <div className={classes["container"]}>
      <div className={classes["total-item"]}>
        <div>
          {t("مجموع_اقلام")}
        </div>

        <div className={classes["number"]}>
          {thousandSeparator(subtotal)}
        </div>
      </div>

      <div className={classes["total-item"]}>
        <div className={classes["title"]}>
          {t("تخفیف")}
        </div>
        <div className={classes["number"]}>
          {thousandSeparator(-totalFoodDiscounts)}
        </div>
      </div>

      {taxesAndCharges.map(tax =>
        <div
          key={tax.title}
          className={classes["total-item"]}
        >
          <div className={classes["title"]}>
            {tax[`title${languageSuffixMap[i18n.language]}`]}{" "}
            {tax.isPercentageModel ? `(${tax.percentage}%)` : ""}
          </div>

          <div className={classes["number"]}>
            {thousandSeparator(tax.amount)}
          </div>
        </div>
      )}

      <div className={classes["total-container"]}>
        <div className={classes["total-text"]}>
          {t("جمع_نهایی")}
        </div>

        <div className={classes["total"]}>
          {thousandSeparator(total)}
        </div>
      </div>
    </div>
  )
}

export default KcSummery